import { useCallback, useEffect, useState } from "react";
import { listarCentros } from "../../../../services/centrosService";
import { showToast } from "../../../../utils/showToast";

export default function useCentrosListado() {
  const [centros, setCentros] = useState([]);
  const [loadingCentros, setLoadingCentros] = useState(false);
  const [centrosError, setCentrosError] = useState(null);

  const cargarCentros = useCallback(async () => {
    setLoadingCentros(true);
    try {
      const data = await listarCentros();
      setCentros(Array.isArray(data) ? data : []);
      setCentrosError(null);
    } catch (err) {
      console.error(err);
      const msg = err.message || "No se pudo cargar la lista de centros.";
      setCentrosError(msg);
      showToast({ type: "danger", message: msg });
    } finally {
      setLoadingCentros(false);
    }
  }, []);

  useEffect(() => {
    cargarCentros();
  }, [cargarCentros]);

  return { centros, loadingCentros, centrosError, reloadCentros: cargarCentros };
}
